import { render, staticRenderFns } from "./TextResources.vue?vue&type=template&id=55b943ad&"
import script from "./TextResources.vue?vue&type=script&lang=ts&"
export * from "./TextResources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports